// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/react-perfect-scrollbar/dist/css/styles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./_iconmoons.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./profile-dropdown.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./footer.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#root {
  background-color: white;
}

body {
  margin: 0;
  font-size: 14px;
  line-height: 1.43;
  overflow-x: hidden;
}
body button,
body span,
body label,
body th,
body td,
body h4,
body h3,
body h2,
body h1,
body p,
body input,
body label {
  font-family: "Fira Sans", "sans-serif" !important;
}

h4 {
  color: #545e6b;
}

select,
input,
textarea {
  font-family: Fira Sans;
}

a,
a:hover {
  color: #1b87e6;
}

.highcharts-series-hover .highcharts-point {
  opacity: 0.3;
}
.highcharts-series-hover .highcharts-point-hover {
  opacity: 1;
}

.autocomplete-tag-wrapper {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 10px 0;
  min-height: 16px;
  width: 100%;
}

.autocomplete-tag-wrapper + input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: transparent;
}

.MuiDialog-container .MuiDialog-paperFullWidth {
  max-width: fit-content;
}

.qp-btn-separator {
  width: 1px;
  display: inline-block;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  background: #e5e5e5;
}

.qp-btn {
  align-items: center;
  display: inline-flex;
  gap: 5px;
  font-size: 12px;
  min-height: 34px;
  line-height: 1;
  position: relative;
  z-index: 0;
  border-width: initial;
  border-style: initial;
  border-color: initial;
  border-image: initial;
  margin: 0;
  overflow: hidden;
  transition: all 0.15s ease-in-out 0s;
  background: none;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
}
.qp-btn.qp-border-btn {
  border: 1px solid aliceblue;
}
.qp-btn.qp-big-btn {
  min-width: 200px;
}
.qp-btn.qp-medium-btn {
  min-width: 150px;
}
.qp-btn.qp-small-btn {
  max-height: 34px;
  justify-content: center;
  min-width: 100px;
}
.qp-btn[disabled] {
  cursor: not-allowed !important;
  opacity: 0.6;
}
.qp-btn.qp-btn-pagination {
  min-width: 110px;
  padding: 6px 12px 5px 18px;
  justify-content: center;
}
.qp-btn.qp-btn-pagination.qp-secondary-btn {
  color: #545e6b;
}
.qp-btn .MuiInputBase-root {
  border: 0;
  background: transparent;
}
.qp-btn .MuiInputBase-root .MuiInputBase-input {
  padding: 0 30px 0 7px;
}
.qp-btn.qp-border-btn {
  border: 1px solid transparent;
}
.qp-btn.qp-btn-nrm {
  padding: 6px 7px 5px 7px;
}
.qp-btn.qp-link-btn {
  position: relative;
  margin: 0;
  color: #545e6b;
}
.qp-btn.qp-link-btn:hover {
  opacity: 0.6;
}
.qp-btn.qp-link-btn.qp-link-arrow {
  padding-right: 20px;
  color: #545e6b;
}
.qp-btn.qp-link-btn.qp-link-arrow::after {
  content: "";
  position: absolute;
  right: 7px;
  top: 50%;
  border-top: 4px solid #545e6b;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}
.qp-btn.qp-link-btn.qp-icon-btn svg {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.qp-btn.qp-reply-btn {
  padding: 8px 40px;
  color: #1b87e6;
  font-size: 14px;
  font-weight: 400;
}
.qp-btn.qp-primary-btn {
  background: #1b87e6;
  color: #ffffff;
  font-weight: normal;
}
.qp-btn.qp-primary-btn:hover {
  color: white;
  background: #54a5ec;
}
.qp-btn.qp-primary-btn.qp-border-btn {
  border-color: #ffffff;
}
.qp-btn.qp-secondary-btn {
  color: #1b87e6;
  font-weight: 400;
}
.qp-btn.qp-secondary-btn.qp-border-btn {
  border-color: #1b87e6;
}
.qp-btn.qp-secondary-btn:hover::before {
  opacity: 0.07;
  transform: scale(1);
}
.qp-btn.qp-secondary-btn:hover.qp-arrow-btn::after {
  border-top-color: #555;
}
.qp-btn.qp-secondary-btn::before {
  bottom: 0px;
  content: "";
  display: block;
  left: 0px;
  opacity: 0;
  position: absolute;
  right: 0px;
  top: 0px;
  transform: scale(0);
  transition-duration: 0.15s;
  transition-property: transform, opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  z-index: -1;
  background: #202124;
  border-radius: 3px;
}
.qp-btn.qp-secondary-btn.qp-arrow-btn {
  color: #545e6b;
  margin-bottom: 4px;
}
.qp-btn span {
  display: inline-block;
  font-weight: 400;
  line-height: 23px;
  vertical-align: middle;
  padding-left: 8px;
}

.MuiTouchRipple-root {
  display: none;
}

.MuiAutocomplete-inputRoot .autocomplete-tag-wrapper + .MuiAutocomplete-input {
  flex: 0 0 100%;
  width: 100%;
  opacity: 0;
  position: absolute;
  left: 0;
}

.keywords-wrapper .keywords-popup {
  position: fixed;
  display: flex;
  flex-direction: column;
  width: fit-content;
  padding: 10px;
  color: #fff;
  border: 1px solid #e7ebee;
  padding: 5px 10px;
  font-size: 0.75rem;
  max-width: 300px;
  word-wrap: break-word;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  font-family: Fira Sans, sans-serif;
  font-weight: 400;
  line-height: 1.2;
  border-radius: 0;
  background-color: #444;
  z-index: 9999;
}
.keywords-wrapper span {
  display: inline-block;
  font-weight: 600;
}
.keywords-wrapper .positive {
  color: #1ba758;
}
.keywords-wrapper .negative {
  color: #ff7681;
}

.relative {
  position: relative;
}

body .relative-loader {
  position: relative;
}
body .fixed-loader {
  min-height: 200px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.qp-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  max-height: 0px;
  min-width: 300px;
  z-index: -999;
  pointer-events: none;
  opacity: 0;
  border: none;
  color: #555;
  transition: all 0.4s ease;
}
.qp-dropdown.qp-dropdown-open {
  max-height: 1000px;
  z-index: 999;
  opacity: 1;
  pointer-events: all;
  box-shadow: 1px 3px 8px 1px rgba(0, 0, 0, 0.15);
}

.flex {
  display: flex;
}

.flex-right {
  justify-content: flex-end;
}

.qp-dropdown-item {
  height: 55px;
  display: flex;
}
.qp-dropdown-item:hover {
  background-color: #ededed;
  cursor: pointer;
}
.qp-dropdown-item:hover .qp-dropwodn-extra {
  display: flex;
}

.qp-arrow-rotate {
  transform: rotate(-180deg);
}

.qp-item-title {
  color: #555;
  display: block;
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
}

.qp-item-subtitle {
  color: #808792;
  display: block;
  font-weight: 300;
  font-size: 11px;
}

.qp-form-row {
  margin: 15px 0;
}

.qp-form-maxwidth {
  max-width: 600px;
}

.qp-dropdown-content {
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 0 15px 0 22px;
}
.qp-dropdown-content::after {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background: #dcdcdc;
  content: "";
}

.qp-dropwodn-extra {
  position: relative;
  display: none;
  flex-direction: column;
  justify-content: center;
  padding: 0 15px;
  font-size: 11px;
  overflow: hidden;
}
.qp-dropwodn-extra::after {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background: #dcdcdc;
  content: "";
}
.qp-dropwodn-extra:hover {
  background-color: #ccc;
}

.qp-form-error {
  font-size: 11px;
  color: #bd0000;
  min-height: 14px;
}

.mbot-20 {
  margin-bottom: 20px;
}

.mbot-25 {
  margin-bottom: 25px;
}

.contact-sales-form {
  max-width: 700px !important;
}

.MuiFormHelperText-root {
  margin-bottom: 0;
}

.MuiDialog-container .MuiDialog-paper .MuiDialogActions-root {
  padding: 10px 15px;
  border-top: 1px solid #ddd;
}

.dialog-header {
  position: relative;
  background: #f4f4f4;
  text-align: center;
  padding: 10px 15px;
}
.dialog-header span {
  align-items: center;
  color: #555555;
  display: inline-flex;
  margin: 0;
  font-size: 18px;
  text-align: center;
  font-weight: 500;
}
.dialog-header .dialog-close-icon {
  position: absolute;
  right: 0;
  top: 0;
  margin: 10px;
  cursor: pointer;
}
.dialog-header .dialog-close-icon:hover {
  opacity: 0.6;
}

.medium-dialog .MuiDialog-paper {
  min-width: 400px;
}
.medium-dialog textarea {
  min-height: 100px;
}

.qp-form-group {
  position: relative;
  display: flex;
  flex-flow: column;
  flex-wrap: wrap;
  gap: 2px;
  min-height: 1px;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}
.qp-form-group .qp-control-label {
  width: 100%;
  color: #545e6b;
  align-items: center;
  display: flex;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 7px;
  margin-top: 7px;
  padding: 0;
  text-align: left;
}
.qp-form-group .qp-control-label.required::after {
  content: " *";
  color: #bd0000;
}
.qp-form-group .this-wrapper {
  width: 70%;
  display: flex;
  position: relative;
  flex-direction: column;
}
.qp-form-group.no-padding {
  padding-left: 0;
  padding-right: 0;
}
.qp-form-group .qp-form-input {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.04);
  border: none;
  color: #545e6b;
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  max-width: 100%;
  min-width: 100%;
  padding: 6px 8px;
  position: relative;
  vertical-align: top;
  outline: none;
}
.qp-form-group .line-flow {
  width: 0;
  height: 1px;
  bottom: 0;
  display: block;
  left: 50%;
  overflow: hidden;
  position: absolute;
  -webkit-transform: translate(-50%, 0);
  -moz-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  -o-transform: translate(-50%, 0);
  transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  -webkit-transition: all 0.15s ease-in-out;
  z-index: 0;
}
.qp-form-group .qp-form-input:focus ~ .line-flow {
  width: 100%;
  background: #1b87e6;
}
.qp-form-group .error {
  width: 100%;
  color: #d8000c;
  display: block;
  font-size: 12px;
  font-weight: 300;
  padding-top: 5px;
  text-align: left;
}

.qp-dropdown-item-icon {
  width: 47px;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 60% auto;
}

.MuiRating-root .MuiRating-iconEmpty {
  color: #ebebeb;
}

.qp-dropdown ul {
  padding: 0;
  margin: 0;
}
.qp-dropdown > ul > li:not(:hover) .qp-dropdown-border {
  background-color: #fff !important;
}
.qp-dropdown li {
  position: relative;
  list-style: none;
}
.qp-dropdown li .qp-dropdown-border {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  opacity: 0.5;
  z-index: 1;
}
.qp-dropdown li ul.dropdown-submenu li .qp-submenu-border {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  opacity: 0.5;
  z-index: 1;
}
.qp-dropdown li ul.dropdown-submenu li .qp-submenu-icon {
  display: block;
  margin: 2px auto;
  width: 15px;
  height: 15px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  filter: invert(0.6);
}
.qp-dropdown li ul.dropdown-submenu li .product-logo {
  width: 16px;
  height: 16px;
  filter: invert(43%) sepia(97%) saturate(701%) hue-rotate(178deg) brightness(88%) contrast(106%);
  -webkit-filter: invert(43%) sepia(97%) saturate(701%) hue-rotate(178deg) brightness(88%) contrast(106%);
}
.qp-dropdown li ul.dropdown-submenu li:hover, .qp-dropdown li ul.dropdown-submenu li.active {
  background: rgba(0, 0, 0, 0.03);
}
.qp-dropdown li ul.dropdown-submenu li:hover .qp-submenu-border, .qp-dropdown li ul.dropdown-submenu li.active .qp-submenu-border {
  opacity: 1;
}
.qp-dropdown li ul.dropdown-submenu li:hover .product-text-inner,
.qp-dropdown li ul.dropdown-submenu li:hover i, .qp-dropdown li ul.dropdown-submenu li.active .product-text-inner,
.qp-dropdown li ul.dropdown-submenu li.active i {
  color: #004693;
}
.qp-dropdown li ul.dropdown-submenu li:hover::after, .qp-dropdown li ul.dropdown-submenu li.active::after {
  opacity: 1;
}
.qp-dropdown li ul.dropdown-submenu li:hover .product-logo, .qp-dropdown li ul.dropdown-submenu li.active .product-logo {
  filter: invert(83%) sepia(97%) saturate(701%) hue-rotate(178deg) brightness(88%) contrast(106%);
  -webkit-filter: invert(83%) sepia(97%) saturate(701%) hue-rotate(178deg) brightness(88%) contrast(106%);
}
.qp-dropdown li .shadow-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 10;
}
.qp-dropdown li .shadow-box::before {
  width: 0;
  height: 8px;
  background-color: #fff;
  bottom: 0;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
  content: "";
  left: 3px;
  position: absolute;
}
.qp-dropdown li .shadow-box::after {
  height: 4px;
  bottom: unset;
  box-shadow: 0 -3px 5px 0 rgba(0, 0, 0, 0.1);
  left: 0;
  top: 0;
}
.qp-dropdown li:hover .qp-submenu-border {
  display: block;
}
.qp-dropdown li:hover .shadow-box::before, .qp-dropdown li:hover .shadow-box::after {
  width: calc(100% - 2px);
}
.qp-dropdown li:hover .dropdown-submenu {
  box-shadow: 1px 3px 8px 1px rgba(0, 0, 0, 0.15);
  left: 100%;
  -moz-opacity: 1;
  -khtml-opacity: 1;
  -webkit-opacity: 1;
  opacity: 1;
}
.qp-dropdown li:hover::after {
  width: 100%;
}
.qp-dropdown li .product-arrow {
  position: absolute;
  top: 50%;
  right: 10px;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
}
.qp-dropdown li .product-arrow .MuiSvgIcon-root {
  height: 12px;
  width: 12px;
  color: #555;
}
.qp-dropdown li .product-link {
  height: 60px;
  display: block;
  background: #fff;
  font-weight: 300;
  position: relative;
  cursor: default;
}
.qp-dropdown li .product-icon {
  width: 60px;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 62% auto;
  float: left;
}
.qp-dropdown li .product-text {
  color: #555;
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 0 60px;
  overflow: hidden;
  position: relative;
  top: 50%;
  text-overflow: ellipsis;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  white-space: nowrap;
}
.qp-dropdown li .product-text small {
  color: #808792;
  display: block;
  font-weight: 300;
}
.qp-dropdown .dropdown-submenu {
  height: 100%;
  background: #fff;
  display: flex;
  left: 0;
  -moz-opacity: 0;
  -khtml-opacity: 0;
  -webkit-opacity: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transition: all 0.3s ease-in-out 0s, visibility 0s linear 0.3s, z-index 0s linear 10ms;
  z-index: -1;
}
.qp-dropdown .dropdown-submenu li {
  position: relative;
  min-height: 61px;
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  white-space: nowrap;
}
.qp-dropdown .dropdown-submenu li.active .dropdown-link {
  cursor: default;
}
.qp-dropdown .dropdown-submenu li .dropdown-link {
  text-decoration: none;
  min-width: 92px;
  padding: 9px 6px 4px;
  text-align: center;
  word-break: break-word;
  cursor: pointer;
}
.qp-dropdown .dropdown-submenu li .dropdown-link i {
  color: #1b87e6;
  font-size: 15px;
  font-weight: 600;
}
.qp-dropdown .dropdown-submenu li .dropdown-link .product-text-inner {
  color: #555;
  display: block;
  font-size: 13px;
  font-weight: 400;
  line-height: normal;
}

.livechat {
  display: flex !important;
  align-items: center;
}
.livechat::after {
  width: 8px;
  height: 8px;
  background-color: #3fca5a;
  border-radius: 50%;
  content: " ";
  margin: -1px 0 0 10px;
}

.SnackbarContainer-top {
  top: 0 !important;
}
.SnackbarContainer-top .MuiCollapse-wrapper {
  padding: 0 !important;
  margin-bottom: 10px;
}

.dashboard-view {
  background-color: #fff;
}

.filters_Relative {
  position: relative !important;
  top: unset !important;
  left: unset !important;
  right: unset !important;
  padding: 0px !important;
}

.mt_30 {
  margin-top: 30px;
}

.scrollbar-divs::-webkit-scrollbar {
  display: none;
}

.dialogContentReply {
  width: 100% !important;
}

.first_inputs {
  width: 50%;
  padding-right: 10px;
}

.first_inputs:nth-child(2) {
  padding-right: 0;
}

.first {
  display: flex;
  width: 100%;
}

svg.highcharts-root,
svg.highcharts-root text {
  font-family: Fira Sans !important;
  color: #545e6b !important;
  font-size: 12px !important;
}

th,
td {
  color: #545e6b !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 16px;
  word-wrap: break-word;
}

th {
  font-weight: 500 !important;
  /* Override the font-weight for th */
}`, "",{"version":3,"sources":["webpack://./src/styles/scss/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,uBAAA;AAGF;;AADA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAIF;AAHE;;;;;;;;;;;;EAYE,iDAAA;AAKJ;;AADA;EACE,cAAA;AAIF;;AADA;;;EAGE,sBAAA;AAIF;;AADA;;EAEE,cAAA;AAIF;;AADE;EACE,YAAA;AAIJ;AAFE;EACE,UAAA;AAIJ;;AADA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;AAIF;;AADA;EACE,oBAAA;EACA,kBAAA;AAIF;;AAAE;EACE,sBAAA;AAGJ;;AACA;EACE,UAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAEF;;AACA;EACE,mBAAA;EACA,oBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;EAEA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AACF;AACE;EACE,2BAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,8BAAA;EACA,YAAA;AAHJ;AAME;EACE,gBAAA;EACA,0BAAA;EACA,uBAAA;AAJJ;AAMI;EACE,cAAA;AAJN;AAQE;EACE,SAAA;EACA,uBAAA;AANJ;AAQI;EACE,qBAAA;AANN;AAUE;EACE,6BAAA;AARJ;AAWE;EACE,wBAAA;AATJ;AAYE;EACE,kBAAA;EACA,SAAA;EACA,cAAA;AAVJ;AAYI;EACE,YAAA;AAVN;AAaI;EACE,mBAAA;EACA,cAAA;AAXN;AAaM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,6BAAA;EACA,kCAAA;EACA,mCAAA;AAXR;AAgBM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAdR;AAmBE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;AAlBJ;AAoBI;EACE,YAAA;EAEA,mBAAA;AAnBN;AAsBI;EACE,qBAAA;AApBN;AAwBE;EACE,cAAA;EACA,gBAAA;AAtBJ;AAwBI;EACE,qBAAA;AAtBN;AA0BM;EACE,aAAA;EACA,mBAAA;AAxBR;AA4BQ;EACE,sBAAA;AA1BV;AA+BI;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EACA,0BAAA;EACA,uCAAA;EACA,wDAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA7BN;AAoCI;EAEE,cAAA;EACA,kBAAA;AAnCN;AAgDE;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AA9CJ;;AAkDA;EACE,aAAA;AA/CF;;AAkDA;EACE,cAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;AA/CF;;AAmDE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,4CAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;AAhDJ;AAmDE;EACE,qBAAA;EACA,gBAAA;AAjDJ;AAoDE;EACE,cAAA;AAlDJ;AAqDE;EACE,cAAA;AAnDJ;;AAuDA;EACE,kBAAA;AApDF;;AAwDE;EACE,kBAAA;AArDJ;AAwDE;EACE,iBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AAtDJ;;AA0DA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AAvDF;AAyDE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,+CAAA;AAvDJ;;AA2DA;EACE,aAAA;AAxDF;;AA2DA;EACE,yBAAA;AAxDF;;AA2DA;EACE,YAAA;EACA,aAAA;AAxDF;AA0DE;EACE,yBAAA;EACA,eAAA;AAxDJ;AA0DI;EACE,aAAA;AAxDN;;AA6DA;EACE,0BAAA;AA1DF;;AA6DA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA1DF;;AA6DA;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA1DF;;AA6DA;EACE,cAAA;AA1DF;;AA6DA;EACE,gBAAA;AA1DF;;AA6DA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AA1DF;AA4DE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;AA1DJ;;AA8DA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AA3DF;AA6DE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;AA3DJ;AA8DE;EACE,sBAAA;AA5DJ;;AAgEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AA7DF;;AAgEA;EACE,mBAAA;AA7DF;;AA+DA;EACE,mBAAA;AA5DF;;AA8DA;EACE,2BAAA;AA3DF;;AA6DA;EACE,gBAAA;AA1DF;;AA+DI;EACE,kBAAA;EACA,0BAAA;AA5DN;;AAiEA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AA9DF;AAgEE;EACE,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA9DJ;AAiEE;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;AA/DJ;AAiEI;EACE,YAAA;AA/DN;;AAqEE;EACE,gBAAA;AAlEJ;AAqEE;EACE,iBAAA;AAnEJ;;AAuEA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EAEA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AArEF;AAuEE;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AArEJ;AAwEE;EACE,aAAA;EACA,cAAA;AAtEJ;AAyEE;EACE,UAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;AAvEJ;AA0EE;EACE,eAAA;EACA,gBAAA;AAxEJ;AA2EE;EACE,WAAA;EACA,qCAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AAzEJ;AA4EE;EACE,QAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,iCAAA;EACA,sCAAA;EACA,oCAAA;EACA,yCAAA;EACA,UAAA;AA1EJ;AA6EE;EACE,WAAA;EACA,mBAAA;AA3EJ;AA8EE;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA5EJ;;AAgFA;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;AA7EF;;AAiFE;EACE,cAAA;AA9EJ;;AAmFE;EACE,UAAA;EACA,SAAA;AAhFJ;AAsFQ;EACE,iCAAA;AApFV;AA0FE;EACE,kBAAA;EACA,gBAAA;AAxFJ;AA0FI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAxFN;AA6FQ;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA3FV;AA8FQ;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;AA5FV;AA8FQ;EACE,WAAA;EACA,YAAA;EACA,+FAAA;EACA,uGAAA;AA5FV;AA8FQ;EAME,+BAAA;AAjGV;AA6FU;EACE,UAAA;AA3FZ;AAgGU;;;EAEE,cAAA;AA7FZ;AAgGU;EACE,UAAA;AA9FZ;AAiGU;EACE,+FAAA;EACA,uGAAA;AA/FZ;AAqGI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AAnGN;AAqGM;EACE,QAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;EACA,0CAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AAnGR;AAsGM;EACE,WAAA;EACA,aAAA;EACA,2CAAA;EACA,OAAA;EACA,MAAA;AApGR;AAyGM;EACE,cAAA;AAvGR;AA2GQ;EAEE,uBAAA;AA1GV;AA8GM;EACE,+CAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AA5GR;AA+GM;EACE,WAAA;AA7GR;AAiHI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;AA/GN;AAiHM;EACE,YAAA;EACA,WAAA;EACA,WAAA;AA/GR;AAmHI;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAjHN;AAoHI;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,WAAA;AAlHN;AAqHI;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,mBAAA;AAnHN;AAqHM;EACE,cAAA;EACA,cAAA;EACA,gBAAA;AAnHR;AAwHE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,OAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,sFAAA;EACA,WAAA;AAtHJ;AAwHI;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAtHN;AAyHQ;EACE,eAAA;AAvHV;AA2HM;EACE,qBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAzHR;AA2HQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAzHV;AA4HQ;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA1HV;;AAgIA;EACE,wBAAA;EACA,mBAAA;AA7HF;AA8HE;EACE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AA5HJ;;AAgIA;EACE,iBAAA;AA7HF;AA+HE;EACE,qBAAA;EACA,mBAAA;AA7HJ;;AAgIA;EACE,sBAAA;AA7HF;;AA+HA;EACE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AA5HF;;AA8HA;EACE,gBAAA;AA3HF;;AA6HA;EACE,aAAA;AA1HF;;AA4HA;EACE,sBAAA;AAzHF;;AA2HA;EACE,UAAA;EACA,mBAAA;AAxHF;;AA0HA;EACE,gBAAA;AAvHF;;AAyHA;EACE,aAAA;EACA,WAAA;AAtHF;;AAyHA;;EAEE,iCAAA;EACA,yBAAA;EACA,0BAAA;AAtHF;;AA0HA;;EAEE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,iBAAA;EACA,qBAAA;AAvHF;;AAyHA;EACE,2BAAA;EAA6B,oCAAA;AArH/B","sourcesContent":["@import '~react-perfect-scrollbar/dist/css/styles.css';\n@import url('./_iconmoons.scss');\n\n#root {\n  background-color: white;\n}\nbody {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.43;\n  overflow-x: hidden;\n  button,\n  span,\n  label,\n  th,\n  td,\n  h4,\n  h3,\n  h2,\n  h1,\n  p,\n  input,\n  label {\n    font-family: 'Fira Sans', 'sans-serif' !important;\n  }\n}\n\nh4 {\n  color: #545e6b;\n}\n\nselect,\ninput,\ntextarea {\n  font-family: Fira Sans;\n}\n\na,\na:hover {\n  color: #1b87e6;\n}\n.highcharts-series-hover {\n  .highcharts-point {\n    opacity: 0.3;\n  }\n  .highcharts-point-hover {\n    opacity: 1;\n  }\n}\n.autocomplete-tag-wrapper {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 10px 0;\n  min-height: 16px;\n  width: 100%;\n}\n\n.autocomplete-tag-wrapper + input::-webkit-input-placeholder {\n  /* WebKit browsers */\n  color: transparent;\n}\n\n.MuiDialog-container {\n  .MuiDialog-paperFullWidth {\n    max-width: fit-content;\n  }\n}\n\n.qp-btn-separator {\n  width: 1px;\n  display: inline-block;\n  height: 30px;\n  margin-left: 5px;\n  margin-right: 5px;\n  background: rgb(229, 229, 229);\n}\n\n.qp-btn {\n  align-items: center;\n  display: inline-flex;\n  gap: 5px;\n  font-size: 12px;\n  min-height: 34px;\n  line-height: 1;\n  position: relative;\n  z-index: 0;\n  border-width: initial;\n  border-style: initial;\n  border-color: initial;\n  border-image: initial;\n  margin: 0;\n  overflow: hidden;\n  // padding: 8px 16px;\n  transition: all 0.15s ease-in-out 0s;\n  background: none;\n  border-radius: 3px;\n  cursor: pointer;\n  outline: none;\n\n  &.qp-border-btn {\n    border: 1px solid aliceblue;\n  }\n\n  &.qp-big-btn {\n    min-width: 200px;\n  }\n\n  &.qp-medium-btn {\n    min-width: 150px;\n  }\n\n  &.qp-small-btn {\n    max-height: 34px;\n    justify-content: center;\n    min-width: 100px;\n  }\n\n  &[disabled] {\n    cursor: not-allowed !important;\n    opacity: 0.6;\n  }\n\n  &.qp-btn-pagination {\n    min-width: 110px;\n    padding: 6px 12px 5px 18px;\n    justify-content: center;\n\n    &.qp-secondary-btn {\n      color: #545e6b;\n    }\n  }\n\n  .MuiInputBase-root {\n    border: 0;\n    background: transparent;\n\n    .MuiInputBase-input {\n      padding: 0 30px 0 7px;\n    }\n  }\n\n  &.qp-border-btn {\n    border: 1px solid transparent;\n  }\n\n  &.qp-btn-nrm {\n    padding: 6px 7px 5px 7px;\n  }\n\n  &.qp-link-btn {\n    position: relative;\n    margin: 0;\n    color: #545e6b;\n\n    &:hover {\n      opacity: 0.6;\n    }\n\n    &.qp-link-arrow {\n      padding-right: 20px;\n      color: #545e6b;\n\n      &::after {\n        content: '';\n        position: absolute;\n        right: 7px;\n        top: 50%;\n        border-top: 4px solid #545e6b;\n        border-left: 4px solid transparent;\n        border-right: 4px solid transparent;\n      }\n    }\n\n    &.qp-icon-btn {\n      svg {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  &.qp-reply-btn {\n    padding: 8px 40px;\n    color: #1b87e6;\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  &.qp-primary-btn {\n    background: rgb(27, 135, 230);\n    color: #ffffff;\n    font-weight: normal;\n\n    &:hover {\n      color: rgb(255, 255, 255);\n      // background: rgb(34, 182, 255);\n      background: #54a5ec;\n    }\n\n    &.qp-border-btn {\n      border-color: #ffffff;\n    }\n  }\n\n  &.qp-secondary-btn {\n    color: rgb(27, 135, 230);\n    font-weight: 400;\n\n    &.qp-border-btn {\n      border-color: rgb(27, 135, 230);\n    }\n\n    &:hover {\n      &::before {\n        opacity: 0.07;\n        transform: scale(1);\n      }\n\n      &.qp-arrow-btn {\n        &::after {\n          border-top-color: #555;\n        }\n      }\n    }\n\n    &::before {\n      bottom: 0px;\n      content: '';\n      display: block;\n      left: 0px;\n      opacity: 0;\n      position: absolute;\n      right: 0px;\n      top: 0px;\n      transform: scale(0);\n      transition-duration: 0.15s;\n      transition-property: transform, opacity;\n      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n      z-index: -1;\n      background: rgb(32, 33, 36);\n      border-radius: 3px;\n    }\n\n    // svg {\n    //   color: #545e6b;\n    // }\n\n    &.qp-arrow-btn {\n      //padding: 6px 24px 5px 7px;\n      color: #545e6b;\n      margin-bottom: 4px;\n      // &::after {\n      //    content: '';\n      //   position: absolute;\n      //   right: 10px;\n      //   bottom: 12px;\n      //   border-top: 4px solid #545e6b;\n      //   border-left: 4px solid transparent;\n      //   border-right: 4px solid transparent;\n      // }\n    }\n  }\n\n  span {\n    display: inline-block;\n    font-weight: 400;\n    line-height: 23px;\n    vertical-align: middle;\n    padding-left: 8px;\n  }\n}\n\n.MuiTouchRipple-root {\n  display: none;\n}\n\n.MuiAutocomplete-inputRoot .autocomplete-tag-wrapper + .MuiAutocomplete-input {\n  flex: 0 0 100%;\n  width: 100%;\n  opacity: 0;\n  position: absolute;\n  left: 0;\n}\n\n.keywords-wrapper {\n  .keywords-popup {\n    position: fixed;\n    display: flex;\n    flex-direction: column;\n    width: fit-content;\n    padding: 10px;\n    color: #fff;\n    border: 1px solid #e7ebee;\n    padding: 5px 10px;\n    font-size: 0.75rem;\n    max-width: 300px;\n    word-wrap: break-word;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);\n    font-family: Fira Sans, sans-serif;\n    font-weight: 400;\n    line-height: 1.2;\n    border-radius: 0;\n    background-color: #444;\n    z-index: 9999;\n  }\n\n  span {\n    display: inline-block;\n    font-weight: 600;\n  }\n\n  .positive {\n    color: #1ba758;\n  }\n\n  .negative {\n    color: #ff7681;\n  }\n}\n\n.relative {\n  position: relative;\n}\n\nbody {\n  .relative-loader {\n    position: relative;\n  }\n\n  .fixed-loader {\n    min-height: 200px;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.qp-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  max-height: 0px;\n  min-width: 300px;\n  z-index: -999;\n  pointer-events: none;\n  opacity: 0;\n  border: none;\n  color: #555;\n  transition: all 0.4s ease;\n\n  &.qp-dropdown-open {\n    max-height: 1000px;\n    z-index: 999;\n    opacity: 1;\n    pointer-events: all;\n    box-shadow: 1px 3px 8px 1px rgba(0, 0, 0, 0.15);\n  }\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-right {\n  justify-content: flex-end;\n}\n\n.qp-dropdown-item {\n  height: 55px;\n  display: flex;\n\n  &:hover {\n    background-color: #ededed;\n    cursor: pointer;\n\n    .qp-dropwodn-extra {\n      display: flex;\n    }\n  }\n}\n\n.qp-arrow-rotate {\n  transform: rotate(-180deg);\n}\n\n.qp-item-title {\n  color: #555;\n  display: block;\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 500;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n}\n\n.qp-item-subtitle {\n  color: #808792;\n  display: block;\n  font-weight: 300;\n  font-size: 11px;\n}\n\n.qp-form-row {\n  margin: 15px 0;\n}\n\n.qp-form-maxwidth {\n  max-width: 600px;\n}\n\n.qp-dropdown-content {\n  position: relative;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  padding: 0 15px 0 22px;\n\n  &::after {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 1px;\n    background: #dcdcdc;\n    content: '';\n  }\n}\n\n.qp-dropwodn-extra {\n  position: relative;\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 15px;\n  font-size: 11px;\n  overflow: hidden;\n\n  &::after {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 1px;\n    background: #dcdcdc;\n    content: '';\n  }\n\n  &:hover {\n    background-color: #ccc;\n  }\n}\n\n.qp-form-error {\n  font-size: 11px;\n  color: #bd0000;\n  min-height: 14px;\n}\n\n.mbot-20 {\n  margin-bottom: 20px;\n}\n.mbot-25 {\n  margin-bottom: 25px;\n}\n.contact-sales-form {\n  max-width: 700px !important;\n}\n.MuiFormHelperText-root {\n  margin-bottom: 0;\n}\n\n.MuiDialog-container {\n  .MuiDialog-paper {\n    .MuiDialogActions-root {\n      padding: 10px 15px;\n      border-top: 1px solid #ddd;\n    }\n  }\n}\n\n.dialog-header {\n  position: relative;\n  background: #f4f4f4;\n  text-align: center;\n  padding: 10px 15px;\n\n  span {\n    align-items: center;\n    color: #555555;\n    display: inline-flex;\n    margin: 0;\n    font-size: 18px;\n    text-align: center;\n    font-weight: 500;\n  }\n\n  .dialog-close-icon {\n    position: absolute;\n    right: 0;\n    top: 0;\n    margin: 10px;\n    cursor: pointer;\n\n    &:hover {\n      opacity: 0.6;\n    }\n  }\n}\n\n.medium-dialog {\n  .MuiDialog-paper {\n    min-width: 400px;\n  }\n\n  textarea {\n    min-height: 100px;\n  }\n}\n\n.qp-form-group {\n  position: relative;\n  display: flex;\n  flex-flow: column;\n  flex-wrap: wrap;\n  gap: 2px;\n  //align-items: center;\n  min-height: 1px;\n  width: 100%;\n  padding-left: 10px;\n  padding-right: 10px;\n\n  .qp-control-label {\n    width: 100%;\n    color: #545e6b;\n    align-items: center;\n    display: flex;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px;\n    margin-bottom: 7px;\n    margin-top: 7px;\n    padding: 0;\n    text-align: left;\n  }\n\n  .qp-control-label.required::after {\n    content: '\\00a0*';\n    color: #bd0000;\n  }\n\n  .this-wrapper {\n    width: 70%;\n    display: flex;\n    position: relative;\n    flex-direction: column;\n  }\n\n  &.no-padding {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .qp-form-input {\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.04);\n    border: none;\n    color: #545e6b;\n    display: inline-block;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px;\n    max-width: 100%;\n    min-width: 100%;\n    padding: calc((30px - 18px) / 2) 8px;\n    position: relative;\n    vertical-align: top;\n    outline: none;\n  }\n\n  .line-flow {\n    width: 0;\n    height: 1px;\n    bottom: 0;\n    display: block;\n    left: 50%;\n    overflow: hidden;\n    position: absolute;\n    -webkit-transform: translate(-50%, 0);\n    -moz-transform: translate(-50%, 0);\n    -ms-transform: translate(-50%, 0);\n    -o-transform: translate(-50%, 0);\n    transition: all 0.15s ease-in-out;\n    -moz-transition: all 0.15s ease-in-out;\n    -o-transition: all 0.15s ease-in-out;\n    -webkit-transition: all 0.15s ease-in-out;\n    z-index: 0;\n  }\n\n  .qp-form-input:focus ~ .line-flow {\n    width: 100%;\n    background: #1b87e6;\n  }\n\n  .error {\n    width: 100%;\n    color: #d8000c;\n    display: block;\n    font-size: 12px;\n    font-weight: 300;\n    padding-top: 5px;\n    text-align: left;\n  }\n}\n\n.qp-dropdown-item-icon {\n  width: 47px;\n  height: 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 60% auto;\n}\n\n.MuiRating-root {\n  .MuiRating-iconEmpty {\n    color: #ebebeb;\n  }\n}\n\n.qp-dropdown {\n  ul {\n    padding: 0;\n    margin: 0;\n  }\n\n  > ul {\n    > li {\n      &:not(:hover) {\n        .qp-dropdown-border {\n          background-color: #fff !important;\n        }\n      }\n    }\n  }\n\n  li {\n    position: relative;\n    list-style: none;\n\n    .qp-dropdown-border {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 4px;\n      opacity: 0.5;\n      z-index: 1;\n    }\n\n    ul.dropdown-submenu {\n      li {\n        .qp-submenu-border {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 4px;\n          opacity: 0.5;\n          z-index: 1;\n        }\n\n        .qp-submenu-icon {\n          display: block;\n          margin: 2px auto;\n          width: 15px;\n          height: 15px;\n          background-size: contain;\n          background-position: center;\n          background-repeat: no-repeat;\n          filter: invert(0.6);\n        }\n        .product-logo {\n          width: 16px;\n          height: 16px;\n          filter: invert(43%) sepia(97%) saturate(701%) hue-rotate(178deg) brightness(88%) contrast(106%);\n          -webkit-filter: invert(43%) sepia(97%) saturate(701%) hue-rotate(178deg) brightness(88%) contrast(106%);\n        }\n        &:hover,\n        &.active {\n          .qp-submenu-border {\n            opacity: 1;\n          }\n\n          background: rgba(0, 0, 0, 0.03);\n\n          .product-text-inner,\n          i {\n            color: #004693;\n          }\n\n          &::after {\n            opacity: 1;\n          }\n\n          .product-logo {\n            filter: invert(83%) sepia(97%) saturate(701%) hue-rotate(178deg) brightness(88%) contrast(106%);\n            -webkit-filter: invert(83%) sepia(97%) saturate(701%) hue-rotate(178deg) brightness(88%) contrast(106%);\n          }\n        }\n      }\n    }\n\n    .shadow-box {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      z-index: 10;\n\n      &::before {\n        width: 0;\n        height: 8px;\n        background-color: #fff;\n        bottom: 0;\n        box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);\n        content: '';\n        left: 3px;\n        position: absolute;\n      }\n\n      &::after {\n        height: 4px;\n        bottom: unset;\n        box-shadow: 0 -3px 5px 0 rgba(0, 0, 0, 0.1);\n        left: 0;\n        top: 0;\n      }\n    }\n\n    &:hover {\n      .qp-submenu-border {\n        display: block;\n      }\n\n      .shadow-box {\n        &::before,\n        &::after {\n          width: calc(100% - 2px);\n        }\n      }\n\n      .dropdown-submenu {\n        box-shadow: 1px 3px 8px 1px rgba(0, 0, 0, 0.15);\n        left: 100%;\n        -moz-opacity: 1;\n        -khtml-opacity: 1;\n        -webkit-opacity: 1;\n        opacity: 1;\n      }\n\n      &::after {\n        width: 100%;\n      }\n    }\n\n    .product-arrow {\n      position: absolute;\n      top: 50%;\n      right: 10px;\n      -webkit-transform: translate(0, -50%);\n      -moz-transform: translate(0, -50%);\n      -ms-transform: translate(0, -50%);\n      -o-transform: translate(0, -50%);\n\n      .MuiSvgIcon-root {\n        height: 12px;\n        width: 12px;\n        color: #555;\n      }\n    }\n\n    .product-link {\n      height: 60px;\n      display: block;\n      background: #fff;\n      font-weight: 300;\n      position: relative;\n      cursor: default;\n    }\n\n    .product-icon {\n      width: 60px;\n      height: 100%;\n      background-position: center;\n      background-repeat: no-repeat;\n      background-size: 62% auto;\n      float: left;\n    }\n\n    .product-text {\n      color: #555;\n      display: block;\n      font-size: 14px;\n      font-weight: 500;\n      margin: 0 0 0 60px;\n      overflow: hidden;\n      position: relative;\n      top: 50%;\n      text-overflow: ellipsis;\n      -webkit-transform: translate(0, -50%);\n      -moz-transform: translate(0, -50%);\n      -ms-transform: translate(0, -50%);\n      -o-transform: translate(0, -50%);\n      white-space: nowrap;\n\n      small {\n        color: #808792;\n        display: block;\n        font-weight: 300;\n      }\n    }\n  }\n\n  .dropdown-submenu {\n    height: 100%;\n    background: #fff;\n    display: flex;\n    left: 0;\n    -moz-opacity: 0;\n    -khtml-opacity: 0;\n    -webkit-opacity: 0;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    transition: all 0.3s ease-in-out 0s, visibility 0s linear 0.3s, z-index 0s linear 10ms;\n    z-index: -1;\n\n    li {\n      position: relative;\n      min-height: 61px;\n      align-items: center;\n      display: flex;\n      justify-content: center;\n      position: relative;\n      white-space: nowrap;\n\n      &.active {\n        .dropdown-link {\n          cursor: default;\n        }\n      }\n\n      .dropdown-link {\n        text-decoration: none;\n        min-width: 92px;\n        padding: 9px 6px 4px;\n        text-align: center;\n        word-break: break-word;\n        cursor: pointer;\n\n        i {\n          color: #1b87e6;\n          font-size: 15px;\n          font-weight: 600;\n        }\n\n        .product-text-inner {\n          color: #555;\n          display: block;\n          font-size: 13px;\n          font-weight: 400;\n          line-height: normal;\n        }\n      }\n    }\n  }\n}\n.livechat {\n  display: flex !important;\n  align-items: center;\n  &::after {\n    width: 8px;\n    height: 8px;\n    background-color: #3fca5a;\n    border-radius: 50%;\n    content: ' ';\n    margin: -1px 0 0 10px;\n  }\n}\n\n.SnackbarContainer-top {\n  top: 0 !important;\n\n  .MuiCollapse-wrapper {\n    padding: 0 !important;\n    margin-bottom: 10px;\n  }\n}\n.dashboard-view {\n  background-color: #fff;\n}\n.filters_Relative {\n  position: relative !important;\n  top: unset !important;\n  left: unset !important;\n  right: unset !important;\n  padding: 0px !important;\n}\n.mt_30 {\n  margin-top: 30px;\n}\n.scrollbar-divs::-webkit-scrollbar {\n  display: none;\n}\n.dialogContentReply {\n  width: 100% !important;\n}\n.first_inputs {\n  width: 50%;\n  padding-right: 10px;\n}\n.first_inputs:nth-child(2) {\n  padding-right: 0;\n}\n.first {\n  display: flex;\n  width: 100%;\n}\n\nsvg.highcharts-root,\nsvg.highcharts-root text {\n  font-family: Fira Sans !important;\n  color: #545e6b !important;\n  font-size: 12px !important;\n}\n\n// table\nth,\ntd {\n  color: #545e6b !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 16px;\n  word-wrap: break-word;\n}\nth {\n  font-weight: 500 !important; /* Override the font-weight for th */\n}\n\n@import url('./profile-dropdown.scss');\n@import url('./footer.scss');\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
